export const getBackendUrl = () => {
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  return 'https://api.shivajirajan.com';
};

export const BACKEND_URL = getBackendUrl();


